/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Pavel Reznak (reznak@cadwork.cz)
 */

import Pass from "App/render/webgl/passes/pass";
import WebGLRenderGraph from "App/render/webgl/render_graph";
import HUDShader from "App/render/webgl/shaders/environment/hud";
import View from "App/view/view";
import {Framebuffer} from "App/utils/frame_buffer";
import WebGLContext from "App/web_gl_context";
import {Factory, Containers} from "App/utils/factory";
import {HUDBinTypeName} from "App/render/webgl/nodes/bins/type_names";
import IScene from "js_interface/src/scene_interface";

/**
 * Controls and other things for clipping plane
 *
 * @param {SceneAPI.Scene} aSceneAPI
 * @param {WebGLRenderGraph} aRenderGraph
 * @class
 * @extends Pass
 */
export default
class Controls extends Pass {

    public static TypeName: string = "Controls";

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph) {
        super(aSceneAPI, aRenderGraph);
    }

    public static create(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph): Controls {
        return new Controls(aSceneAPI, aRenderGraph);
    }

    /**
     * Initialize values
     */
    public initialize() {
        let hudShaders = this._renderGraph.getLayer('hud').getShaders();

        this._shadersToBins = {};

        this.attachShaderToBin(HUDBinTypeName, hudShaders.get(HUDShader.TypeName));
    }

    /**
     * Release
     */
    public release() {
        //
    }

    public render(aView: View, aOutput: Framebuffer) {
        let scale = aOutput.getParameters().scale;
        /** @type WebGLRenderingContext */
        let gl = (this._context as WebGLContext).getWebGLRenderingContext();
        let bins = this._renderGraph.getRenderBins();
        this.view = aView;

        let position = aView.getPosition();
        let size = aView.getSize();

        gl.enable(gl.SCISSOR_TEST);
        gl.viewport(position[0] * scale, position[1] * scale, size[0] * scale, size[1] * scale);
        gl.scissor(position[0] * scale, position[1] * scale, size[0] * scale, size[1] * scale);

        // Output to texture
        aOutput.bind();

        // Clear texture
        gl.clearColor(0.0, 0.0, 0.0, 0.0);
        gl.clear(gl.DEPTH_BUFFER_BIT | gl.COLOR_BUFFER_BIT);

        bins.get(HUDBinTypeName).renderControls(this);

        aOutput.unbind();

        gl.disable(gl.SCISSOR_TEST);
        this.view = null;
    }
}

Factory.register(Containers.PASSES_CONTROLS, Controls);
